import React, { Component } from "react";
import Rodal from "rodal";

import ConfirmAndSaveConfirmDialog from "./ConfirmAndSaveConfirmDialog";

export default class ConfirmAndSaveButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDialogVisible: false,
    };
  }

  showDialog = () => {
    this.setState({
      isDialogVisible: true,
    });
  };

  hideDialog = () => {
    this.setState({
      isDialogVisible: false,
    });
  };

  onClickConfirm = () => {
    this.hideDialog();
    this.props.confirmAndSave();
  };

  render() {
    return (
      <div>
        <Rodal
          width={800}
          height={613}
          visible={this.state.isDialogVisible}
          onClose={this.hideDialog}
        >
          <ConfirmAndSaveConfirmDialog
            currentLeaveCarryYears={this.props.currentLeaveCarryYears}
            hideDialog={this.hideDialog}
            onClickConfirm={this.onClickConfirm}
          />
        </Rodal>
        <div
          className="col-sm-6"
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <div className="col-sm-3">
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.showDialog}
              disabled={this.props.disableSave}
            >
              Confirm and Save
            </button>
          </div>
        </div>
      </div>
    );
  }
}
